import { Controller } from "@hotwired/stimulus";

// Clears the PostHog identity on sign out so the next session is anonymous.
export default class extends Controller {
  reset() {
    if (window.posthog) window.posthog.reset();
  }
}
